import "./header.css";
import { Button, Col, Row } from "antd";
import { useState, useContext, useEffect } from "react";
import { PatientModal } from "../componentsIndex";
import { ShowContext } from "../../context/Context";
const Header = ({ ButtonHide }) => {
  const ctx = useContext(ShowContext);
  const [showLogin, setShowLogin] = useState(false);
  const [patientName, setPatientName] = useState("");
  const [patientData, setPatientData] = useState(null);

  useEffect(() => {
    if (ctx.patientData) {
      setPatientData(ctx.patientData);
    }
  }, [ctx.patientData]);

  useEffect(() => {
    if (patientData) {
      if (patientData?.entry) {
        const name =
          (patientData.entry[0]?.resource?.name[0]?.given?.[0] || "") +
          " " +
          (patientData.entry[0]?.resource?.gender || "") +
          " " +
          (patientData.entry[0]?.resource?.birthDate || "") +
          " (" +
          (patientData.entry[0]?.resource?.id || "") +
          ")";
        setPatientName(name);
        return;
      }
      const name =
        patientData?.name[0]?.given[0] +
        " " +
        patientData?.name[0]?.family +
        " " +
        (patientData?.gender || "") +
        " " +
        (patientData.birthDate ? patientData.birthDate : "") +
        "(" +
        patientData.id +
        ")";
      setPatientName(name);
    }
  }, [patientData]);
  return (
    <div className="headerContainer">
      <Row className="headerWrapper">
        <Col span={4} className="titleSection">
          <p>{ButtonHide === "hide" ? "Launcher" : "Patient Viewer"}</p>
        </Col>
        {patientName && (
          <Col span={14} className="dataSection">
            <p
              style={{ visibility: ButtonHide === "hide" ? "hidden" : "show" }}
            >
              {patientName}
            </p>
          </Col>
        )}
        <Col span={4} className="buttonSection">
          <Button
            style={{ visibility: ButtonHide === "hide" ? "hidden" : "show" }}
            type="primary"
            onClick={() => setShowLogin(true)}
          >
            Select Patient
          </Button>
        </Col>
        <PatientModal
          setSummaryPatientName={setPatientName}
          setShowLogin={setShowLogin}
          summaryPatientName={patientName}
          show={showLogin}
          close={() => setShowLogin(false)}
        />
      </Row>
    </div>
  );
};

export default Header;
